// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"loader_lds-dual-ring__IZQK6"};